module.exports = __webpack_public_path__ + "static/media/extension-add-problem-blue.80262625.svg";